import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import React, { FC, Suspense, useEffect } from 'react';
import { useAtomValue } from 'jotai';
import { hostname, useDialogs, NewVersionDialog } from '@idk-web/core-ui';
import app from '@/utils/app';
import { language as languageAtom } from '@/state/locale';
import useNewVersionAvailable from '@/hooks/useNewVersionAvailable';
import InboxApp from '@/components/inbox/InboxApp';

const App: FC = () => {
  const { i18n } = useTranslation();
  const language = useAtomValue(languageAtom);
  const dialog = useDialogs();

  useEffect(() => {
    void i18n.changeLanguage(language);
  }, [language]);

  useNewVersionAvailable(() => {
    dialog.open(NewVersionDialog);
  }, []);

  return (
    <>
      <Helmet>
        <title>{hostname.tld === 'se' ? 'IDkollen' : 'Identisure'}</title>
      </Helmet>
      {app.env === 'prod' && (
        <Helmet>
          <script
            async
            src="https://www.googletagmanager.com/gtag/js?id=G-2XPWH7F7HH"
          ></script>
          <script>
            {`
              window.dataLayer = window.dataLayer || [];
              function gtag(){ dataLayer.push(arguments); }
              gtag('js', new Date());
              gtag('config', 'G-2XPWH7F7HH');
            `}
          </script>
        </Helmet>
      )}
      <Suspense fallback={null}>
        <InboxApp />
      </Suspense>
    </>
  );
};

export default App;
